const colors = {
  background: '#fafafa',

  // Tones
  white: '#ffffff', // Same as legacy p06

  // Neutrals
  neutral_200: '#f1f2f3',
  neutral_300: '#e8eaed',
  neutral_400: '#cfd4db',

  // Greys
  grey_100: '#5f7089',
  grey_100_50: '#afb7c4', // Solid (opaque) version of 50% transparency
  grey_200: '#3b4960',
  grey_200_12: 'rgba(59, 73, 96, 0.12)',
  grey_300: '#1f2d44',
  grey_disabled: '#dedede',
  disabled_grey: '#EBECEE',

  // Greens
  green_200: '#0a875a',

  // Reds
  red_100: '#c31d2b',
  red_200: '#b11b27',

  // Oranges
  orange_200: '#e55e38',

  // Blues
  blue_700: '#0057B2',
};

export default colors;
